import * as XLSX from 'xlsx';

export const spreadsheetExportService = {
  /**
   * Export filtered data to Excel format
   * @param {Array} data - The filtered data to export
   * @param {Object} visibleColumns - Object of visible column names
   * @param {string} filename - The filename to save as (without extension)
   */
  exportToExcel: (data, visibleColumns, filename = 'spreadsheet_export') => {
    try {
      // Prepare data for export
      const exportData = data.map(row => {
        const exportRow = {};
        Object.keys(visibleColumns).forEach(columnKey => {
          exportRow[columnKey] = row[columnKey] || '';
        });
        return exportRow;
      });

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Set column widths
      const columnWidths = Object.keys(visibleColumns).map(() => ({ wch: 20 }));
      worksheet['!cols'] = columnWidths;

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, `${filename}.xlsx`);
      
      return { success: true };
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      return { success: false, error: error.message };
    }
  },

  /**
   * Export filtered data to CSV format
   * @param {Array} data - The filtered data to export
   * @param {Object} visibleColumns - Object of visible column names
   * @param {string} filename - The filename to save as (without extension)
   */
  exportToCSV: (data, visibleColumns, filename = 'spreadsheet_export') => {
    try {
      // Prepare data for export
      const exportData = data.map(row => {
        const exportRow = {};
        Object.keys(visibleColumns).forEach(columnKey => {
          exportRow[columnKey] = row[columnKey] || '';
        });
        return exportRow;
      });

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Convert to CSV
      const csv = XLSX.utils.sheet_to_csv(worksheet);

      // Create blob and trigger download
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return { success: true };
    } catch (error) {
      console.error('Error exporting to CSV:', error);
      return { success: false, error: error.message };
    }
  },
};